import React, {Component} from 'react';
import ShiftDetails from '../parts/ShiftDetails';
import {connect} from 'react-redux';
import {fetchJobsIfNeeded} from "../state/actions/jobs";
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';
import {fetchManagersIfNeeded} from "../state/actions/managers";
import ShiftProgress from "../parts/ShiftProgress";
import ShiftPaymentSummary from "../parts/ShiftPaymentSummary";


// TODO currently shift detail relies on the whole shifts array. We should ideally be using the /shift/{id} endpoint

class ShiftDetailsModal extends Component {
  componentDidMount() {
    window.analytics.track("Business Dashboard - Opened Shift Details", {slug: this.props.business.slug});

    this.props.fetchJobsIfNeeded();
  }

  componentWillUnmount() {
    window.analytics.track("Business Dashboard - Closed Shift Details", {slug: this.props.business.slug});
  }

  render() {
    const {classes, shift} = this.props;

    return (
      <React.Fragment>
        <AppBar position={'sticky'} color={'secondary'}>
          <Toolbar>
            <IconButton className={classes.backButton} onClick={this.props.closeShiftModal} color="inherit"
                        aria-label="Menu">
              <ArrowBack/>
            </IconButton>
            <Typography variant="title">Shift Details</Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.content}>
          <ShiftProgress shift={shift}/>
          <ShiftDetails shift={shift}/>
          <ShiftPaymentSummary shift={shift}/>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  jobs: state.jobs.items,
  managers: state.managers.items,
  business: state.business.item,
});

const mapDispatchToProps = (dispatch) => ({
  fetchJobsIfNeeded: () => dispatch(fetchJobsIfNeeded()),
  fetchManagersIfNeeded: (business) => dispatch(fetchManagersIfNeeded(business)),
});


const styles = (theme) => ({
  content: {
    padding: theme.spacing.unit * 3,
    textAlign: 'left',
  },
  backButton: {
    marginRight: theme.spacing.unit * 3,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ShiftDetailsModal));


// WEBPACK FOOTER //
// ./src/modals/ShiftDetailsModal.js